/* eslint-disable no-undef */
import getHostEndpoint from '@/utils/getHostEndpoint';
export default function useWPUrls() {
  const WP_HOST = ref(process.env.VUE_APP_WP_API);
  if (getHostEndpoint('wp_host')) {
    WP_HOST.value = getHostEndpoint('wp_host');
  }
  const WP_REST = ref(`${WP_HOST.value}/wp-json`);
  return {
    WP_HOST,
    WP_REST
  };
}